var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakeAsCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 6.66667C1.99996 5.03333 3.17329 3.68667 4.71996 3.39333L3.72663 4.39333L4.66663 5.33333L7.33329 2.66L4.66663 0L3.72663 0.94L4.77996 1.99333V2.03333C2.46663 2.30667 0.666626 4.28 0.666626 6.66667C0.666626 9.24667 2.75329 11.3333 5.33329 11.3333H7.33329V10H5.33329C3.49329 10 1.99996 8.50667 1.99996 6.66667Z",
    fill: "#57585A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 6.66663V11.3333H14.6666V6.66663H8.66663ZM13.3333 9.99996H9.99996V7.99996H13.3333V9.99996Z",
    fill: "#57585A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 0.666626H8.66663V5.33329H14.6666V0.666626Z",
    fill: "#57585A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeAsCover);
export default __webpack_public_path__ + "static/media/MakeAsCover.529a0bfb88a22b33eeaf9612a51aa58c.svg";
export { ForwardRef as ReactComponent };